<script setup lang="ts">
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'
import {LOCAL_STORAGE_KEY_HIDE_NOTIFICATION_BANNER_UNTIL} from '@/services/Notification/NotificationService'
import {useNotificationsStore} from '@/stores/notifications'
import {computed} from 'vue'
import {useI18n} from 'vue-i18n'

const BANNER_DELAY_TIME = 3_600_000 // 1 hour

const notificationsStore = useNotificationsStore()
const {t, locale} = useI18n()
const isNewUiEnabled = useNewUiEnabled()

const containerClassName = computed(() => ({
  'flex flex-wrap w-[325px] z-20 relative': true,
  'bg-red p-3': !isNewUiEnabled.value,
  'bg-new-red-500 px-new-xl py-new-lg rounded-new-xl text-white shadow-new-md': isNewUiEnabled.value,
  // italian and german text is longer than english
  'w-[425px]': locale.value === 'it',
  'w-[375px]': locale.value === 'de',
}))

const newUiActionClassName = 'cursor-pointer text-new-sm font-medium uppercase tracking-wide text-new-neutral-0 hover:text-white'

function handleClickSolveNow() {
  notificationsStore.showBanner = false
  notificationsStore.showSidePanel = true
}

/**
 * hide banner and set delay time in localStorage
 */
function handleClickLater() {
  const hideUntil = new Date().getTime() + BANNER_DELAY_TIME

  localStorage.setItem(LOCAL_STORAGE_KEY_HIDE_NOTIFICATION_BANNER_UNTIL, hideUntil.toString())
  notificationsStore.showBanner = false
}
</script>

<template>
  <div v-if="notificationsStore.showBanner" :class="containerClassName">
    <div class="w-full flex" :class="isNewUiEnabled ? 'items-start gap-new-md' : ''">
      <div :class="isNewUiEnabled ? 'shrink-0' : 'w-[10%] flex items-start'">
        <div class="border border-white rounded-full w-8 h-8 flex items-center justify-center">
          <i class="fa-regular fa-bell text-white" :class="isNewUiEnabled ? 'text-new-lg' : 'text-2xl'" />
        </div>
      </div>
      <div :class="isNewUiEnabled ? 'min-w-0 flex-1 pt-new-sm' : 'w-[90%] flex flex-wrap mt-1 pl-3'">
        <p :class="isNewUiEnabled ? 'text-new-md font-medium text-white' : 'text-white text-xl font-bold'">
          {{ t('notifications.banner.title') }}
        </p>
      </div>
    </div>
    <div class="w-full flex justify-end" :class="isNewUiEnabled ? 'gap-new-xl mt-new-xl' : 'space-x-4 mt-3'">
      <button
        :class="
          isNewUiEnabled ? newUiActionClassName : 'cursor-pointer text-lightgrey text-sm font-bold uppercase hover:text-white'
        "
        type="button"
        @click="handleClickSolveNow"
      >
        {{ t('notifications.solveNow') }}
      </button>
      <button
        :class="
          isNewUiEnabled ? newUiActionClassName : 'cursor-pointer text-lightgrey text-sm font-bold uppercase hover:text-white'
        "
        type="button"
        @click="handleClickLater"
      >
        {{ t('notifications.banner.later') }}
      </button>
    </div>
  </div>
</template>
